import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiInstagram, FiTwitter, FiMail, FiHeart } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="bg-bloom-text text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-bloom-yellow rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiHeart} className="text-bloom-text text-sm" />
              </div>
              <span className="font-bold text-2xl tracking-tight">Bento Bloom</span>
            </Link>
            <p className="text-gray-400 max-w-sm mb-6">
              Making lunch preparation a joy, not a chore. Premium bento boxes, brilliant accessories, and foolproof recipes for the whole family.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-bloom-coral transition-colors">
                <SafeIcon icon={FiInstagram} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-bloom-mint transition-colors">
                <SafeIcon icon={FiTwitter} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-bloom-yellow transition-colors">
                <SafeIcon icon={FiMail} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6 text-bloom-yellow">Shop</h4>
            <ul className="space-y-4 text-gray-400">
              <li><Link to="/shop" className="hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">Bento Boxes</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">Recipe Kits</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">Bundles</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6 text-bloom-mint">Support</h4>
            <ul className="space-y-4 text-gray-400">
              <li><Link to="/support" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/support" className="hover:text-white transition-colors">Shipping & Returns</Link></li>
              <li><Link to="/support" className="hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link to="/support" className="hover:text-white transition-colors">Care Guide</Link></li>
            </ul>
          </div>

        </div>
        
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} Bento Bloom. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
          </div>
        </div>
        <p className="mt-6 text-center text-sm text-gray-500" style={{ textTransform: "none" }}>Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer">LingLinkAI.cn</a></p>
      </div>
    </footer>
  );
}